export const MAP_LAYERS_PANEL_RIGHT_OFFSET = 12;
